module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir12-03327828b547d9169e4e655ff8c76212.jpg";